module.exports = __webpack_public_path__ + "media/src/img/search-icon-faa8a7dbfac5fd67f15d826f0798537e.svg";